export const cilXCircle = ["24 24","<path d='M16.316 6.624l-4.114 4.114-4.114-4.114-1.061 1.061 4.114 4.114-4.114 4.114 1.061 1.061 4.114-4.114 4.114 4.114 1.061-1.061-4.114-4.114 4.114-4.114-1.061-1.061z'></path><path d='M19.955 4.045c-2.036-2.036-4.848-3.295-7.955-3.295-6.213 0-11.25 5.037-11.25 11.25 0 3.107 1.259 5.919 3.295 7.955v0c2.036 2.036 4.848 3.295 7.955 3.295 6.213 0 11.25-5.037 11.25-11.25 0-3.107-1.259-5.919-3.295-7.955v0zM12 21.75c-5.376 0-9.75-4.374-9.75-9.75s4.374-9.75 9.75-9.75 9.75 4.374 9.75 9.75-4.374 9.75-9.75 9.75z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-x-circle.js
// module id = null
// module chunks = 